import React, { useState } from "react";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { BlueBox, SearchContainer, HidddenButtonContainer } from "../assets/style";
import { IconButton } from '@mui/material';

const SearchBox = ({ children }: { children: React.ReactNode }) => {
    const [hidden, setHidden] = useState(false);

    return (
        <BlueBox>
            <SearchContainer>
                {!hidden && children}
            </SearchContainer>
            <HidddenButtonContainer>
                <IconButton
                    onClick={() => setHidden(!hidden)}
                >
                    {hidden ? < ArrowDropDownIcon fontSize="large" /> : <ArrowDropUpIcon fontSize="large" />}
                </IconButton>
            </HidddenButtonContainer>
        </BlueBox>
    );
};


export default SearchBox;